import React from 'react';

const AuditHeader: React.FC<{ generatedAt?: string }> = ({ generatedAt }) => (
  <div
    className="px-3 py-2 flex items-center justify-between sticky top-0 z-50"
    style={{ background: '#0B1F3B' }}
  >
    <div className="flex items-center gap-3">
      <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-white/10 text-white border border-white/30">
        Shared Report
      </span>
      <span className="text-[11px] text-white/80">MEO Audit</span>
      {generatedAt && (
        <span className="text-xs text-white/60">生成日: {generatedAt}</span>
      )}
    </div>
    <img
      src="/Clariveil.png"
      alt="Clariveil"
      style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
    />
  </div>
);

export default AuditHeader;
